$(function () {
    // $('.q-first-item label').on('click', function () {
    //
    //     if($(this).next().next('.q-second-level').css('display') === 'block'){
    //         $(this).next().next('.q-second-level').slideUp();
    //     } else {
    //         $(this).next().next('.q-second-level').slideDown();
    //     }
    // });
    // $('.q-first-item div').on('click', function () {
    //     $(this).next('.q-second-level').toggle();
    // });
    //
    // $('.q-second-item label').on('click', function () {
    //     if($(this).next().next('.q-third-level').css('display') === 'block'){
    //         $(this).next().next('.q-third-level').slideUp();
    //     } else {
    //         $(this).next().next('.q-third-level').slideDown();
    //     }
    // });

    $('.q-second-item div').on('click', function () {
        $(this).next('.q-third-level').toggle();
    });

    $('.d-item').on('click', function () {
        $(this).next('.sub-block').toggle();
    });

    $(document).mouseup(function (e) { // событие клика по веб-документу
        var div = $(".choose"); // тут указываем ID элемента
        if (!div.is(e.target) && div.has(e.target).length === 0// если клик был не по нашему блоку
            /*&& div.has(e.target).length === 0*/) { // и не по его дочерним элементам
            div.children('.select-list').hide(); // скрываем его
        }
    });

    var lm_height = $('.left-menu-lc').height();
    $('.personal-area .container').css('minHeight', lm_height);

    $('.choose').click(function () {
        var this_list = $(this).children('.select-list');
        this_list.slideToggle();
        $('.select-list').not(this_list).hide();
    });

    $('.select-list li').click(function () {
        var value = $(this).html();
        $(this).parent().prev('.select-area').html(value);
    });

    $('.show-el').click(function () {
        $('.left-menu-lc').css('width', '250');
        $('.name-cat').show();
        $('.show-el').css('display', 'none');
        $('.hide-el').css('display', 'block');
    });

    $('.hide-el').click(function () {
        $('.left-menu-lc').css('width', '67');
        $('.name-cat').hide();
        $('.hide-el').css('display', 'none');
        $('.show-el').css('display', 'block');
    });

    (function () {
        $(".quests").find('input:checkbox:checked').each(function () {
            $(this).siblings("ul").slideDown();
            $(this).parents('ul').slideDown();
            $(this).parent('.size').siblings('textarea').show();
        })
    })();
    $('.quests input:checkbox').on("change", function () {
        var listItem = $(this).closest('li'),
            list = listItem.children('ul'),
            allTextarea = list.find('textarea');
        textarea = listItem.children('textarea');
        listInputs = list.find('input:checkbox');

        if ($(this).prop("checked") === true) {
            list.slideDown();
            $(this).closest('ul').siblings('input:checkbox').prop('checked', 'true').closest('ul').siblings('input:checkbox').prop('checked', 'true');
            if (textarea.length) {
                textarea.css('display', 'block');
            }
        }

        if ($(this).prop("checked") === false) {
            list.slideUp();
            listInputs.each(function () {
                $(this).prop('checked', false);
            });
            allTextarea.each(function () {
                $(this).css('display', 'none');
            });

            if (textarea.length) {
                textarea.css('display', 'none');
            }
        }
    });
    $('.js-validate-checkboxes').on('click', function (event) {
        var thisBtn = $(this);
        event.preventDefault(); //this will prevent the default submit
        var canSubmit = true;
        var childCheckboxes;
        var errorChecks = [];
        var self;
        $('.quests li input:checkbox:checked').each(function (i, item) {
            var textarea = $(item).closest('label').siblings('textarea');
            var validTextarea = textarea.filter(function (index) {
                if (textarea[index].value === '') {
                    $(textarea[index]).closest('.q-first-item').find('input[type="checkbox"]').addClass('errorCheckbox');
                    errorChecks.push($(this).siblings('label').find('.size-text').text());
                    $(textarea[index]).addClass('errorCheckbox');
                    return textarea[index];
                }
            });

            if (validTextarea.length) {
                canSubmit = false;
                return;
            }

            self = $(this);

            self.closest('ul').siblings('input:checkbox').prop('checked', 'true').closest('ul').siblings('input:checkbox').prop('checked', 'true');

            if (self.closest('label').siblings('ul').length > 0) {
                childCheckboxes = self.closest('label').siblings('ul').find('li label input:checkbox:checked').length;
                if (childCheckboxes < 1) {
                    canSubmit = false;
                    errorChecks.push($(this).siblings('div').text());
                    self.parents('ul').parent('li').find('label input[type="checkbox"]').addClass('errorCheckbox');
                    self.addClass('errorCheckbox');
                    self.siblings('ul').find('label input[type="checkbox"]').addClass('errorCheckbox');
                    self.parents('ul').slideDown();
                    self.siblings('ul').slideDown();
                }
            }
        });

        if (canSubmit == false) {
            console.log(errorChecks);
            $('.popupCheckbox').show();
            $('#overlay').show();
            for (var i = 0; i < errorChecks.length; i++) {
                $('.errorChecks').append('<div>' + errorChecks[i] + '</div>');
            }

        } else {
            thisBtn.unbind(event.preventDefault());
            thisBtn.click();
        }

        $('.popupCheckbox .q-back').on('click', function () {
            $('.popupCheckbox').hide();
            $('#overlay').hide();
            $('.errorChecks').html('');
            $(this).off();
        })
        $('.popupCheckbox .q-next').on('click', function () {
            $('.errorCheckbox').prop('checked', false).removeClass('errorCheckbox');
            $('.popupCheckbox').hide();
            $('#overlay').hide();
            $('.errorChecks').html('');
            thisBtn.unbind(event.preventDefault());
            thisBtn.click();
            $(this).off();
        })
    });
    // delete block 'recall-autor-photo' if there is no photo
    var fullRecall = document.querySelector('.full-recall');
    if (fullRecall) {
        var recallAutorPhotoWrap = document.querySelectorAll('.recall-tittle');
        for (var i = 0; i < recallAutorPhotoWrap.length; i++) {
            var recallAutorPhoto = recallAutorPhotoWrap[i].querySelector('.recall-autor-photo'),
                photo = recallAutorPhoto.querySelector('img');
            if (photo.attributes.src === undefined || photo.attributes.src === "") {
                recallAutorPhotoWrap[i].removeChild(recallAutorPhoto);
            }
        }
    }

    // close modal window
    (function () {
        var modalWindow = $('.modal-window');
        var closeModalWindow = $('#close-modal-window');
        var FindOutMore = $('.modal-window__findout-more');
        var showFindOutMore = $('#findout-more-show');
        var closeFindOutMore = $('.modal-window__findout-more-close');

        closeModalWindow.on('click', function () {
            modalWindow.fadeOut();
        });

        showFindOutMore.on('click', function () {
            FindOutMore.fadeIn();
        });

        closeFindOutMore.on('click', function () {
            FindOutMore.fadeOut();
        });
    })();
});

function closeModalWindow(selector) {
    if (!selector) {
        selector = '.modal-window';
    }
    $(selector).fadeOut();
}

function toggleHideShow(selector, flex) {
    var element = document.getElementById(selector);

    var display = flex || 'block';

    if (element.style.display === "none" || element.style.display == "") {
        element.style.display = display;
    } else {
        element.style.display = "none";
    }
};

var discountPercents = function (initialWidth, initialDiscount, fullDiscount, multiplier) {

    var actualDiscount = document.querySelector('.basket-ticket-discount-actual');
    var progressLine = document.querySelector('.basket-ticket-discount-progress');

    if (progressLine) {

        var progressLineData = parseFloat(progressLine.dataset.percent);

        if (progressLineData === fullDiscount) {
            actualDiscount.classList.add('full');
        }

        if (progressLineData > initialDiscount) {
            progressLine.style.width = (progressLineData - initialDiscount) * multiplier + initialWidth + '%';
        }
    }
};
discountPercents(20, 10, 30, 4);

var togglePatientInfo = function () {
    var container = document.querySelector('.anketi-center .an-table');
    var target = null;
    var clone = null;

    function _deleteClone(target, clone) {
        target.parentElement.removeChild(clone);
    }

    if (container) {
        document.addEventListener('click', function (e) {
            if (e.target.classList.contains('get-patient-info')) {
                var info = document.querySelector('.aside-info');
                var cloneInfo = info.cloneNode(true);

                if (target) {
                    _deleteClone(target, clone);
                }

                target = e.target;
                clone = cloneInfo;
                cloneInfo.style.cssText = 'top: 100%; left: 0; z-index: 1';
                target.parentElement.insertBefore(cloneInfo, target.nextSibling);
            } else {
                _deleteClone(target, clone);
                target = null;
            }
        });
    }
};
togglePatientInfo();

// ********* DRAG AND DROP ********** //
// ссылка для правок
// https://learn.javascript.ru/drag-and-drop-objects

var DragManager = new function () {
    var container = document.querySelector('.user-file-upload tbody');

    /**
     * составной объект для хранения информации о переносе:
     * {
     *   elem - элемент, на котором была зажата мышь
     *   avatar - аватар
     *   downX/downY - координаты, на которых был mousedown
     *   shiftX/shiftY - относительный сдвиг курсора от угла элемента
     * }
     */
    var dragObject = {};

    var self = this;

    function onMouseDown(e) {
        var elem;

        if (e.which != 1) return;

        if (e.target.classList.contains('drag-target')) {
            elem = e.target.closest('tr');
        }
        ;

        if (!elem) return;

        dragObject.elem = elem;

        // запомним, что элемент нажат на текущих координатах pageX/pageY
        dragObject.downX = e.pageX;
        dragObject.downY = e.pageY;

        return false;
    }

    function onMouseMove(e) {


        if (!dragObject.elem) return; // элемент не зажат

        if (!dragObject.avatar) { // если перенос не начат...
            var moveX = e.pageX - dragObject.downX;
            var moveY = e.pageY - dragObject.downY;

            // если мышь передвинулась в нажатом состоянии недостаточно далеко
            if (Math.abs(moveX) < 3 && Math.abs(moveY) < 3) {
                return;
            }

            // начинаем перенос
            dragObject.avatar = createAvatar(e); // создать аватар
            if (!dragObject.avatar) { // отмена переноса, нельзя "захватить" за эту часть элемента
                dragObject = {};
                return;
            }

            // аватар создан успешно
            // создать вспомогательные свойства shiftX/shiftY
            var coords = getCoords(dragObject.avatar);
            dragObject.shiftX = dragObject.downX - coords.left;
            dragObject.shiftY = dragObject.downY - coords.top;

            startDrag(e); // отобразить начало переноса

        }

        // отобразить перенос объекта при каждом движении мыши
        dragObject.avatar.style.left = e.pageX - dragObject.shiftX + 'px';
        dragObject.avatar.style.top = e.pageY - dragObject.shiftY + 'px';

        findPlaceForDrop(e);
        return false;
    }

    function onMouseUp(e) {
        if (dragObject.avatar) { // если перенос идет
            finishDrag(e);
        }

        // перенос либо не начинался, либо завершился
        // в любом случае очистим "состояние переноса" dragObject
        dragObject = {};
    }

    function findPlaceForDrop(e) {
        if (!findDroppable(e)) {
            var droppable = document.querySelector('.droppable');
            var boxCoor = droppable.getBoundingClientRect();
            var top = boxCoor.top + pageYOffset;
            var elem;

            if (e.pageY - dragObject.shiftY > top) {
                if (droppable.nextElementSibling) {
                    elem = container.replaceChild(droppable, droppable.nextElementSibling);
                    container.insertBefore(elem, droppable);
                }
            }
            if (e.pageY - dragObject.shiftY < top) {
                if (droppable.previousElementSibling) {
                    container.insertBefore(droppable, droppable.previousElementSibling);
                }
            }
        }
    }

    function finishDrag(e) {
        var dropElem = findDroppable(e);

        if (!dropElem) {
            self.onDragCancel(dragObject);
        } else {
            self.onDragEnd(dragObject, dropElem);
        }
    }

    function createAvatar(e) {

        // запомнить старые свойства, чтобы вернуться к ним при отмене переноса
        var avatar = dragObject.elem;
        var old = {
            parent: avatar.parentNode,
            nextSibling: avatar.nextSibling,
            position: avatar.position || '',
            left: avatar.left || '',
            top: avatar.top || '',
            zIndex: avatar.zIndex || ''
        };

        // функция для отмены переноса
        avatar.rollback = function () {
            var cloneAvatar = container.querySelector('.droppable');
            container.removeChild(cloneAvatar);
            old.parent.insertBefore(avatar, old.nextSibling);
            avatar.style.position = old.position;
            avatar.style.left = old.left;
            avatar.style.top = old.top;
            avatar.style.zIndex = old.zIndex;
        };

        return avatar;
    }

    function startDrag(e) {
        var avatar = dragObject.avatar;
        var cloneAvatar = avatar.cloneNode(true);
        cloneAvatar.style.background = 'orange';
        cloneAvatar.setAttribute('class', 'droppable');
        container.insertBefore(cloneAvatar, avatar);
        var dropElem = findDroppable(e);

        // инициировать начало переноса
        document.body.appendChild(avatar);
        avatar.style.zIndex = 9999;
        avatar.style.position = 'absolute';
    }

    function findDroppable(event) {
        // спрячем переносимый элемент
        dragObject.avatar.hidden = true;

        // получить самый вложенный элемент под курсором мыши
        var elem = document.elementFromPoint(event.clientX, event.clientY);

        // показать переносимый элемент обратно
        dragObject.avatar.hidden = false;

        if (elem == null) {
            // такое возможно, если курсор мыши "вылетел" за границу окна
            return null;
        }

        return elem.closest('.droppable');
    }

    document.onmousemove = onMouseMove;
    document.onmouseup = onMouseUp;
    document.onmousedown = onMouseDown;

    this.onDragEnd = function (dragObject, dropElem) {
    };
    this.onDragCancel = function (dragObject) {
    };

};


function getCoords(elem) { // кроме IE8-
    var box = elem.getBoundingClientRect();

    return {
        top: box.top + pageYOffset,
        left: box.left + pageXOffset
    };

}

DragManager.onDragCancel = function (dragObject) {
    dragObject.avatar.rollback();
};

// DragManager.onDragEnd = function(dragObject, dropElem) {
//     var container = document.querySelector('.user-file-upload tbody');
//     dropElem.classList.add('computer-smile');
//     dragObject.avatar.removeAttribute('style');
//     container.insertBefore(dragObject.avatar, dropElem);
//     container.removeChild(dropElem);
//
//     setTimeout(function() {
//         dropElem.classList.remove('computer-smile');
//     }, 2000);
// };

// ************* CLICK OUT OF MODAL-WINDOW ***************** //

// $(document).on('click', function (e){ // событие клика по веб-документу
//
//     var div = $(".modal-window__inner"); // тут указываем ID элемента
//     if (!div.is(e.target) // если клик был не по нашему блоку
//         && div.has(e.target).length === 0) { // и не по его дочерним элементам
//         $(".modal-window").fadeOut(); // скрываем его
//     }
// });
